import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import { NodeStatus } from "../../models/nodeStatus";
import Joi from "joi-browser";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";

const monitoringNodeSetStatus = [
  { id: 0, value: "", label: "(None selected)" },
  { id: 1, value: NodeStatus.Completed, label: NodeStatus.Completed },
  { id: 2, value: NodeStatus.Failed, label: NodeStatus.Failed },
  { id: 3, value: NodeStatus.Paused, label: NodeStatus.Paused },
  { id: 4, value: NodeStatus.Cancelled, label: NodeStatus.Cancelled },
];

const monitoringSettingTemplate = [
  {
    name: "triggerDescription",
    label: "Condition Trigger",
    description: "Describe when to proceed to the next step?",
    type: "textArea",
    style: { height: "150px" },
  },
  // {
  //   name: "statusToSet",
  //   label: "Status",
  //   type: "select",
  //   options: monitoringNodeSetStatus,
  // },
];

const monitoringSettingSchema = {
  triggerDescription: Joi.string().required().label("Condition Trigger"),
  statusToSet: Joi.string().required().label("Status"),
};

function MonitoringSetting(props) {
  const { monitoringSetting, open, onClose, onSave } = props;
  const { data, validate, error, handleChange, setError } = useForm(
    monitoringSetting,
    monitoringSettingSchema
  );

  function handleSave() {
    const errors = validate(data, monitoringSettingSchema);

    if (errors) {
      setError(errors);
      return;
    }

    onSave(data);
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Next Step Condition</DialogTitle>
      <DialogBody>
        <Form
          data={data}
          template={monitoringSettingTemplate}
          handleChange={handleChange}
          error={error}
        />
      </DialogBody>
      <DialogActions>
        <Button plain onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}

export { MonitoringSetting };
